import React from 'react';

import { DialogContent } from '_lib/components/DialogContent/DialogContent';

import { DialogWrapper } from '_lib/featureComponents/DialogWrapper/DialogWrapper';

import { SERVICE_TITAN_ENTERPRISE_LOGIN_URL } from '_lib/global/config';

import { AsyncDialogProps, useAsyncDialog } from './useAsyncDialog';

export type ServiceTitanEnterpriseLoginDialogProps = AsyncDialogProps;

const ServiceTitanEnterpriseLoginDialog = (props: ServiceTitanEnterpriseLoginDialogProps) => {
  return (
    <DialogWrapper
      {...props}
      sx={[
        {
          '& .MuiPaper-root.MuiDialog-paper': { minWidth: '75%', minHeight: '75%' },
          '& .MuiDialogTitle-root+.MuiDialogContent-root': {
            paddingTop: 0
          }
        }
      ]}
      dismissable={true}
      titleText={'SERVICE TITAN ENTERPRISE LOGIN'}>
      <DialogContent sx={{ display: 'flex', flexGrow: 1, padding: 0 }}>
        <iframe style={{ minWidth: '100%', minHeight: '100%' }} src={SERVICE_TITAN_ENTERPRISE_LOGIN_URL}></iframe>
      </DialogContent>
    </DialogWrapper>
  );
};

export const useServiceTitanEnterpriseLoginDialog = () => useAsyncDialog(ServiceTitanEnterpriseLoginDialog);
